import * as React from "react";

const SvgIcnEdit = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M16.5 19a.5.5 0 110 1h-12a.5.5 0 110-1h12zm3-3a.5.5 0 110 1h-9a.5.5 0 110-1h9zM13.396 5.103l2.5 2.5L6.72 16.78a.75.75 0 01-.53.22H4.75a.75.75 0 01-.75-.75v-1.44a.75.75 0 01.22-.53l9.176-9.177zM16.53 3.03l1.44 1.44a.75.75 0 010 1.06l-1.367 1.366-2.5-2.5L15.47 3.03a.75.75 0 011.06 0z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnEdit;
